var indentStyle = {"indentZero":"_31NFN","indentOne":"LSWKk","indentTwo":"VbCZe","indentThree":"JV3MJ","indentFour":"QTh74","indentFive":"XVzbB","indentSix":"_2zrlH"};

export { indentStyle as i };
//# sourceMappingURL=indentation-284282d7.js.map
